module.exports = __webpack_public_path__ + "static/img/ic_arrow.c2b5c95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/pc/ic_arrow.svg
// module id = Q4i9
// module chunks = 10